import { render, staticRenderFns } from "./billList.vue?vue&type=template&id=2dd0a0d1"
import script from "./billList.vue?vue&type=script&lang=js"
export * from "./billList.vue?vue&type=script&lang=js"
import style0 from "./billList.vue?vue&type=style&index=0&id=2dd0a0d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports